import React from 'react';

const Logs = () => {
  return (
    <div>
      <h1>Logs Page</h1>
      <p>Welcome to the Logs!</p>
    </div>
  );
};

export default Logs;